import { KB_URL } from '../../utils/constants';
const NoCaptures = ({props}) => {
    return (
      <div className="row">
        {props.store.TrafficStore.hasError ? (
            <div className="col-lg-12 text-center my-5">
                <h3>Search Criteria Error</h3>
                <p className="text-danger">{props.store.TrafficStore.errorMessage}</p>
                <p>Adjust your search string and try again.</p>
                <p><a href={`${KB_URL}/articles/jW7r4J9q/searching-requests`} target="_blank" rel="noreferrer">Check our docs</a>, if you need help constructing your search string.</p>
            </div>
        ) : (
            <div className="col-lg-12 text-center my-5">
                <h3>No Matching Requests Found</h3>
                <p>There were no requests found using the search criteria provided.</p>
                <p>Review your search string and try again.</p>
                <p><a href={`${KB_URL}/articles/jW7r4J9q/searching-requests`} target="_blank" rel="noreferrer">Check our docs</a>, if you need help constructing your search string.</p>
            </div>    
        )}
    </div>         
    );
  }
  
  export default NoCaptures;